class TabsContent {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('[role="tab"]');
    this.panels = container.querySelectorAll('[role="tabpanel"]');
    this.tabsList = container.querySelector(".tabs-content__tabs");

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupDraggableScroll();
  }

  setupEventListeners() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleTabClick(e));
      tab.addEventListener("keydown", (e) => this.handleTabKeydown(e));
    });
  }

  handleTabClick(event) {
    const selectedTab = event.currentTarget;
    this.activateTab(selectedTab);
  }

  handleTabKeydown(event) {
    const { key } = event;
    const tabList = Array.from(this.tabs);
    const index = tabList.indexOf(event.currentTarget);

    let targetTab = null;

    if (key === "ArrowLeft") {
      event.preventDefault();
      targetTab = tabList[index - 1] || tabList[tabList.length - 1];
    } else if (key === "ArrowRight") {
      event.preventDefault();
      targetTab = tabList[index + 1] || tabList[0];
    } else if (key === "Home") {
      event.preventDefault();
      targetTab = tabList[0];
    } else if (key === "End") {
      event.preventDefault();
      targetTab = tabList[tabList.length - 1];
    }

    if (targetTab) {
      this.activateTab(targetTab);
      targetTab.focus();
    }
  }

  activateTab(tab) {
    const category = tab.getAttribute("data-category");

    // Update tab states
    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle("is-active", isActive);
      t.setAttribute("aria-selected", isActive);
    });

    // Update panel states
    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute("data-category") === category;
      panel.classList.toggle("is-active", isActive);
    });

    // Scroll tab into view
    this.scrollTabIntoView(tab);
  }

  scrollTabIntoView(tab) {
    // Only scroll if in horizontal mode (mobile/tablet)
    if (
      this.tabsList.style.flexDirection !== "column" &&
      window.innerWidth < 1024
    ) {
      tab.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }

  setupDraggableScroll() {
    let isDown = false;
    let startX;
    let scrollLeft;

    this.tabsList.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - this.tabsList.offsetLeft;
      scrollLeft = this.tabsList.scrollLeft;
    });

    this.tabsList.addEventListener("mouseleave", () => {
      isDown = false;
    });

    this.tabsList.addEventListener("mouseup", () => {
      isDown = false;
    });

    this.tabsList.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.tabsList.offsetLeft;
      const walk = (x - startX) * 1;
      this.tabsList.scrollLeft = scrollLeft - walk;
    });

    // Touch support for mobile
    this.tabsList.addEventListener("touchstart", (e) => {
      isDown = true;
      startX = e.touches[0].pageX - this.tabsList.offsetLeft;
      scrollLeft = this.tabsList.scrollLeft;
    });

    this.tabsList.addEventListener("touchend", () => {
      isDown = false;
    });

    this.tabsList.addEventListener("touchmove", (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - this.tabsList.offsetLeft;
      const walk = (x - startX) * 1;
      this.tabsList.scrollLeft = scrollLeft - walk;
    });
  }
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tabs-content").forEach((container) => {
    new TabsContent(container);
  });
});

// Re-initialize on Shopify section reload
document.addEventListener("shopify:section:load", (event) => {
  const container = event.detail.target.querySelector(".tabs-content");
  if (container) {
    new TabsContent(container);
  }
});
